const TOGGLE = '[data-js="apostas-burger-toggle"]'
const BACK = '[data-js="apostas-burger-back"]'
const OFFCANVAS = '#offcanvasMenu'

const directCollapseChild = (li) => {
  if (!li) return null
  for (const child of li.children) {
    if (child.classList?.contains('collapse')) return child
  }
  return null
}

const resetPanels = () => {
  document.querySelectorAll(`${OFFCANVAS} .collapse.active`).forEach((el) => {
    el.classList.remove('active')
  })
  document.querySelectorAll(`${OFFCANVAS} ${TOGGLE}[aria-expanded="true"]`).forEach((btn) => {
    btn.setAttribute('aria-expanded', 'false')
  })
}

const openPanel = (toggle) => {
  const collapse = directCollapseChild(toggle.closest('li'))
  if (!collapse) return
  collapse.classList.add('active')
  toggle.setAttribute('aria-expanded', 'true')
}

const closePanel = (back) => {
  const collapse = back.closest('.collapse')
  if (!collapse) return
  collapse.classList.remove('active')
  const id = collapse.id
  if (id) {
    document
      .querySelector(`${TOGGLE}[aria-controls="${CSS.escape(id)}"]`)
      ?.setAttribute('aria-expanded', 'false')
  }
}

export const initApostasBurger = () => {
  const offcanvas = document.querySelector(OFFCANVAS)
  if (!offcanvas) return

  offcanvas.addEventListener('click', (event) => {
    const toggle = event.target.closest(TOGGLE)
    if (toggle && offcanvas.contains(toggle)) {
      event.preventDefault()
      openPanel(toggle)
      return
    }

    const back = event.target.closest(BACK)
    if (back && offcanvas.contains(back)) {
      event.preventDefault()
      closePanel(back)
    }
  })

  offcanvas.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    const back = event.target.closest(BACK)
    if (back) {
      event.preventDefault()
      closePanel(back)
    }
  })

  offcanvas.addEventListener('hidden.bs.offcanvas', resetPanels)
}
